import React from 'react';
import { Spinner, Table } from 'react-bootstrap'

import DefaultButton from 'components/mycomponents/DefaultButton';

const Data = ({
    dataMain,
    actionDetail,
    actionEdit,
    actionDelete,
    actionPrint,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">ID Siswa</th>
                    <th scope="col">Nama</th>
                    <th scope="col">Alamat</th>
                    <th scope="col">Sekolah</th>
                    <th className="text-end" scope="col" width="15%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{val.vckode}</td>
                                <td>{val.vcnama}</td>
                                <td>{val.vcalamat}</td>
                                <td>{val.vcsekolah}</td>
                                <td className="text-end">
                                    <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} />
                                    <DefaultButton icon="edit" title="Edit" variant="action" className="p-0 me-3" clickAction={actionEdit} clickParam={val.intid} />
                                    <DefaultButton icon="print" title="Print" variant={parseFloat(val.intprint_card) === 1 ? "info" : "action"} className="p-0 me-3" clickAction={actionPrint} clickParam={val.intid} />
                                    <DefaultButton icon="trash-alt" title="Delete" variant="action" className="p-0" clickAction={actionDelete} clickParam={val.intid} />
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={6}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;